interface UserAgentParts {
    appName: string;
    appVersion: string;
    platformDetails: string;
    buildNumber: string;
}

class UserAgentBuilder {
    private parts: Partial<UserAgentParts> = {};

    setPart<K extends keyof UserAgentParts>(key: K, value: UserAgentParts[K]) {
        this.parts[key] = value;
        return this; // allows chaining
    }

    build(): string {
        const { appName = '', appVersion = '', platformDetails = '', buildNumber ='1' } = this.parts;
        return `${appName}/${appVersion} ${platformDetails} ${buildNumber}`;
    }
}

export default UserAgentBuilder;
